module.exports = __webpack_public_path__ + "static/since-2007-cost-of-spending-has-grown-faster-than-income-2-158d171dfb03a8273365488ea99d3ae3.png";